import type React from 'react';
import { Link } from 'react-router-dom';

export const PublicFooter: React.FC = () => {
  return (
    <footer className="border-t border-border/40 py-8 px-6 backdrop-blur-sm bg-background/80">
      <div className="max-w-6xl mx-auto text-center text-sm text-muted-foreground space-y-2">
        <p>&copy; {new Date().getFullYear()} SteerFi. All rights reserved.</p>
        <Link to="/terms-of-use" className="hover:text-foreground transition-colors">
          Terms of Use
        </Link>
      </div>
    </footer>
  );
};
